import type { SVGProps } from 'react'
const SvgSyArrowUp3 = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M11.748 10.55a.75.75 0 0 0-.75.75v8.95a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V11.3a.75.75 0 0 0-.75-.75"
				opacity={0.4}
			/>
			<path
				fillRule="evenodd"
				d="M11.748 2.613a.75.75 0 0 0-.635.35l-5 7.937a.75.75 0 0 0 .635 1.15H16.75a.75.75 0 0 0 .635-1.15l-5.002-7.937a.75.75 0 0 0-.635-.35m0 2.158 3.643 5.78H8.105z"
				clipRule="evenodd"
			/>
		</g>
	</svg>
)
export default SvgSyArrowUp3
